var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#ffc800",
    r: 4,
    stroke: "#ffc800",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#ff9600",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 12h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 12h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 20v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 3v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.6569 17.6569.7071.7071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.63605 5.63605.7071.7071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.34314 17.6569-.70711.7071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.364 5.63605-.7072.7071"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTheme);
export default __webpack_public_path__ + "static/media/lightTheme.13c2cb18cf95a34ca336c03691ac7b28.svg";
export { ForwardRef as ReactComponent };